import { render, staticRenderFns } from "./WaitShUsers.vue?vue&type=template&id=92fbe268&scoped=true"
import script from "./WaitShUsers.vue?vue&type=script&lang=js"
export * from "./WaitShUsers.vue?vue&type=script&lang=js"
import style0 from "./WaitShUsers.vue?vue&type=style&index=0&id=92fbe268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fbe268",
  null
  
)

export default component.exports